import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cmsDataToModuleArray } from 'components/CmsPage/cmsDataToModuleArray';
import { CmsModules } from 'containers/CmsPage/CmsModules';
import modal from 'decorators/Modal/Modal';
import { decorateWith } from 'helpers/decorator';
import { selectIsMobile } from 'redux/modules/device';
export var mapStateToProps = function mapStateToProps(state, _ref) {
  var modules = _ref.modules,
      backgroundImage = _ref.backgroundImage;
  return {
    bgDesktop: backgroundImage && backgroundImage.image,
    bgMobile: backgroundImage && backgroundImage.imageMobile,
    isMobile: selectIsMobile(state),
    modules: cmsDataToModuleArray(state, {
      modules: modules
    })
  };
};
export var CmsModalUnwrapped = function CmsModalUnwrapped(_ref2) {
  var bgDesktop = _ref2.bgDesktop,
      bgMobile = _ref2.bgMobile,
      isMobile = _ref2.isMobile,
      modules = _ref2.modules;
  var bgImg = isMobile ? bgMobile : bgDesktop;
  return React.createElement("div", {
    style: bgImg && {
      backgroundImage: "url(".concat(bgImg, ")")
    }
  }, React.createElement("div", {
    className: "modal__body"
  }, React.createElement(CmsModules, {
    modules: modules
  })));
};
CmsModalUnwrapped.propTypes = {
  bgDesktop: PropTypes.string,
  bgMobile: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  modules: PropTypes.arrayOf(PropTypes.shape({
    cmsModuleId: PropTypes.string.isRequired
  }).isRequired).isRequired
};
export var CmsModal = decorateWith(modal(), connect(mapStateToProps))(CmsModalUnwrapped);